var map = {
	"./edit/paste.js": 437,
	"./edit/selection.js": 438,
	"./edit/undo.js": 439,
	"./effects/abstract/css.js": 35,
	"./effects/black_and_white.js": 440,
	"./effects/blur.js": 441,
	"./effects/box_blur.js": 442,
	"./effects/brightness.js": 443,
	"./effects/contrast.js": 444,
	"./effects/denoise.js": 445,
	"./effects/dither.js": 446,
	"./effects/dot_screen.js": 447,
	"./effects/edge.js": 448,
	"./effects/emboss.js": 449,
	"./effects/enrich.js": 450,
	"./effects/grains.js": 451,
	"./effects/grayscale.js": 452,
	"./effects/heatmap.js": 453,
	"./effects/hue_rotate.js": 454,
	"./effects/mosaic.js": 455,
	"./effects/negative.js": 456,
	"./effects/oil.js": 457,
	"./effects/saturate.js": 458,
	"./effects/sepia.js": 459,
	"./effects/shadow.js": 460,
	"./effects/sharpen.js": 461,
	"./effects/solarize.js": 462,
	"./effects/tilt_shift.js": 463,
	"./effects/vibrance.js": 464,
	"./effects/vignette.js": 465,
	"./effects/vintage.js": 466,
	"./effects/zoom_blur.js": 468,
	"./file/new.js": 469,
	"./file/open.js": 109,
	"./file/print.js": 470,
	"./file/quickload.js": 471,
	"./file/quicksave.js": 472,
	"./file/save.js": 151,
	"./file/search.js": 148,
	"./help/about.js": 478,
	"./help/shortcuts.js": 479,
	"./help/translate.js": 79,
	"./image/auto_adjust.js": 480,
	"./image/color_corrections.js": 481,
	"./image/decrease_colors.js": 482,
	"./image/flip.js": 483,
	"./image/grid.js": 484,
	"./image/histogram.js": 485,
	"./image/information.js": 486,
	"./image/opacity.js": 487,
	"./image/palette.js": 488,
	"./image/resize.js": 490,
	"./image/rotate.js": 492,
	"./image/size.js": 493,
	"./image/translate.js": 494,
	"./image/trim.js": 80,
	"./image/zoom.js": 495,
	"./layer/clear.js": 496,
	"./layer/composition.js": 497,
	"./layer/delete.js": 498,
	"./layer/differences.js": 499,
	"./layer/duplicate.js": 500,
	"./layer/flatten.js": 501,
	"./layer/merge.js": 502,
	"./layer/move.js": 503,
	"./layer/new.js": 504,
	"./layer/raster.js": 147,
	"./layer/rename.js": 150,
	"./layer/visibility.js": 505,
	"./tools/borders.js": 506,
	"./tools/color_to_alpha.js": 507,
	"./tools/color_zoom.js": 508,
	"./tools/content_fill.js": 509,
	"./tools/keypoints.js": 510,
	"./tools/replace_color.js": 511,
	"./tools/restore_alpha.js": 512,
	"./tools/settings.js": 513,
	"./tools/sprites.js": 514
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;


//////////////////
// WEBPACK FOOTER
// ./src/js/modules \.js$
// module id = 436
// module chunks = 0